import { render, staticRenderFns } from "./BackupsTableSortSkeleton.vue?vue&type=template&id=18eeb430&scoped=true"
import script from "./BackupsTableSortSkeleton.vue?vue&type=script&lang=js"
export * from "./BackupsTableSortSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BackupsTableSortSkeleton.vue?vue&type=style&index=0&id=18eeb430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eeb430",
  null
  
)

export default component.exports